
import { Http } from '@main/common/api'

let strStart = 'Basic '
let strEnd1 = 'U2d5czI0'
let strEnd2 = 'Q3piOkdR'
let strEnd3 = 'REAjMDRw'
let strEnd4 = 'dDE4Yno='

const headers = {
  headers: {
    Authorization: strStart + strEnd1 + strEnd2 + strEnd3 + strEnd4
  }
}

export const apiPostLogin = async (params) => Http.post('/oauth2/token', params, headers)
// export const apiPostLogin = async (params) => Http.post('/oauth2/token', params, {...headers, isAutoCatchStatus: false})
// export const apiPostLogin = async (params) => Http.post('/oauth2/token', params, headers)
// export const apiPostLogin = async (params) => Http.post('/auth/oauth2/token', params, headers)
export const apiPostLogout = async (params) => Http.post('/oauth2/revoke', params, headers)
export const apiGetUserPowers = async () => Http.get('/register/findCurrentUserInfo')

export const apiGetRouter = async () => Http.get('/upms/menu/findRouters')

export const apiGetImage = async () => Http.get('/captcha/image')
export const apiGetSms = async () => Http.get('/captcha/sms')
export const apiGetEmail = async () => Http.get('/captcha/email')

export const apiPostRegisterFirst = async (params) => Http.post('/register/first', params)

/**
 * 根据手机号或邮箱判断用户信息是否存在
 * @param params
 * @return {*|Promise}
 */
export const apiUserExist = async (params) => Http.post('/register/existCurrentUserInfoByMobileOrEmail', params)
/**
 * 根据手机号或邮箱获取用户信息
 * @param params
 * @return {*|Promise}
 */
export const apiUserInfo = async (params) => Http.post('/register/findCurrentUserInfoByMobileOrEmailAndCaptcha', params)

/**
 * 发送短信验证码
 * @param params
 * @return {*|Promise}
 */
export const apiSendCode = async (params) => Http.post('/register/sendMobileCaptcha', params)
export const apiSendCodeLogin = async (params) => Http.post('/register/sendMobileCaptchaForLogin', params)
/**
 * 忘记密码修改密码
 * @param params
 * @return {*|Promise}
 */
export const apiforgetPass = async (params) => Http.post('/register/updatePasswordForget', params)
/**
 *  校验手机短信验证码、图片验证码是否正确
 * @param params
 * @return {*|Promise}
 */
export const apiCheckAllCode = async (params) => Http.post('/register/checkMobileCaptchaAndImageCaptcha', params,{headers:{'Content-Type':'application/x-www-form-urlencoded'}})